import { SetSidebarScreenAction, SET_SIDEBAR_SCREEN, SidebarScreen } from './types';

// eslint-disable-next-line import/prefer-default-export
export const setSidebarScreen = (screen: SidebarScreen): SetSidebarScreenAction => {
    return { type: SET_SIDEBAR_SCREEN, payload: { screen } };
};
